import homeStyles from "../HomeLayout.module.scss";
import styles from "./AppAccessSection.module.scss";
import appStoreBadge from "../../../assets/images/app-store-badge.svg";
import googlePlayBadge from "../../../assets/images/google-play-badge.svg";

const AppAccessSection = () => {
  return (
    <section className={`${homeStyles.section} ${styles.section}`}>
      <h2 className={`${homeStyles.title} ${styles.title}`}>App access</h2>
      <div className={styles.content}>
        <p className={styles.description}>
          Therapeutic Guidelines is available across all devices, with dedicated apps for{" "}
          <strong>iOS</strong> and <strong>Android</strong>
        </p>

        <div className={styles.badgesContainer}>
          <a
            href="https://apps.apple.com/au/app/therapeutic-guidelines/id1099087725"
            className={styles.badgeLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download Therapeutic Guidelines on the App Store"
          >
            <img src={appStoreBadge} alt="Download on the App Store" className={styles.badge} />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=tg.app.twa"
            className={styles.badgeLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get Therapeutic Guidelines on Google Play"
          >
            <img src={googlePlayBadge} alt="Get it on Google Play" className={styles.badge} />
          </a>
        </div>

        <div className={styles.learnMore}>
          <a
            href="https://www.tg.org.au/about-us/faqs/user-guide/"
            className={styles.learnMoreLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn how to install and authenticate the Therapeutic Guidelines app
            <i className={`tg-icons-Open ${styles.externalIcon}`}></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default AppAccessSection;
